import type { MenuTopType } from '../../types/app.d.ts'

import ImageLightTheme from '@/assets/images/lightTheme.png'
import ImageDarkTheme from '@/assets/images/darkTheme.png'
import ImageGrayTheme from '@/assets/images/grayTheme.png'
import ImageEyeProtectionTheme from '@/assets/images/eyeProtectionTheme.png'

export const KEY_LOCAL = 'DNP_'

export const MESSAGE_ERROR = 'Đã xảy ra lỗi. Vui lòng thử lại sau!'
export const PAGINATION = {
  page: 0,
  total: 0,
  current: 1,
  pageSize: 10,
  showQuickJumper: true,
  showSizeChanger: true,
  pageSizeOptions: ['10', '25', '50', '100'],
  showTotal: (total: number) => {
    return 'Tổng số dòng ' + total
  },
}

export const GLOBAL_ROLES = {
  //Thông báo
  NOTI_APP_SEARCH: '/noti-app/search',
  NOTI_APP_CREATE: '/noti-app/create',
  NOTI_APP_DETAIL: '/noti-app/self',
  NOTI_APP_GET_COUNT_UNREAD: '/noti-app/count-unread',
  NOTI_APP_MARK_READ: '/noti-app/mark-read',

  //Quản lý dự án
  PROJECT_MANAGEMENT_SEARCH: '/asset-project/search',
  PROJECT_MANAGEMENT_CREATE: '/asset-project/create',
  PROJECT_MANAGEMENT_UPDATE: '/asset-project/update',
  PROJECT_MANAGEMENT_SELF: '/asset-project/self',
  PROJECT_MANAGEMENT_SEARCH_ASSET: '/asset-project/asset/search',
  PROJECT_MANAGEMENT_GRANT_ASSET: '/asset-project/asset/grant',
  PROJECT_MANAGEMENT_REVOKE_ASSET: '/asset-project/asset/revoke',
  PROJECT_MANAGEMENT_EXPORT_EXCEL: ' /asset-project/export-excel',
  PROJECT_MANAGEMENT_SEARCH_DOCUMENT: '/asset-project/doc/search',
  PROJECT_MANAGEMENT_UPDATE_DOCUMENT: '/asset-project/doc/update',
  //Quản lý nhà thâu
  PROJECT_CONTRACTOR_SEARCH: '/contractor/search',
  PROJECT_CONTRACTOR_CREATE: '/contractor/create',
  PROJECT_CONTRACTOR_UPDATE: '/contractor/update',
  PROJECT_CONTRACTOR_VIEW: '/contractor/view',
  PROJECT_CONTRACTOR_DELETE: '/contractor/delete',
}

export const MODE_ACTION_TO_PAGE = {
  VIEW: '0',
  EDIT: '1',
  CREATE: '2',
  DETAIL_APPRAISAL: '3',
}

// List of themes used in the application
export const LIST_THEMES = [
  {
    key: 1,
    name: 'Giao diện sáng',
    class: 'light-theme',
    img: ImageLightTheme,
  },
  { key: 2, name: 'Giao diện tối', class: 'dark-theme', img: ImageDarkTheme },
  { key: 3, name: 'Giao diện xám', class: 'gray-theme', img: ImageGrayTheme },
  {
    key: 4,
    name: 'Giao diện bảo vệ mắt',
    class: 'eye-protection-theme',
    img: ImageEyeProtectionTheme,
  },
]

export const LS_KEY = 'DNP_' // Local storage key

// Menu top items
export const MENU_TOP: MenuTopType[] = [
  {
    id: 1,
    name: 'Điều hành số liệu',
    open: false,
    type: 'dropdown',
    children: [
      {
        id: 1.1,
        name: 'Điều hành số liệu',
        clientId: 'WP_BOC',
        url: import.meta.env.VITE_WP_BOC_URL,
      },
      {
        id: 1.2,
        name: 'Quản trị mục tiêu và kết quả thực hiện',
      },
    ],
  },
  {
    id: 2,
    name: 'Quản trị doanh nghiệp',
    open: false,
    type: 'dropdown',
    children: [
      {
        id: 2.1,
        name: 'Quản lý khách hàng và dịch vụ',
      },
      {
        id: 2.2,
        name: 'Tổng đài dịch vụ',
        url: import.meta.env.VITE_WP_CCM_URL,
        clientId: 'WP_CCM',
      },
      {
        id: 2.3,
        name: 'Quản lý công việc hiện trường',
      },
      {
        id: 2.4,
        name: 'Quản lý nhân sự, chính sách thu nhập',
        url: import.meta.env.VITE_WP_HRM_URL,
        clientId: 'WP_HRM',
      },
      {
        id: 2.6,
        name: 'Quản lý mua sắm tập trung',
      },
      {
        id: 2.7,
        name: 'Kế toán ngành nước',
      },
    ],
  },
  {
    id: 3,
    name: 'Vận hành kỹ thuật',
    open: false,
    type: 'dropdown',
    children: [
      {
        id: 3.1,
        name: 'Quản lý tài sản nhà máy và mạng lưới',
        url: import.meta.env.VITE_WP_ASM_URL,
        clientId: 'WP_ASM',
      },
      {
        id: 3.2,
        name: 'Quản lý, giám sát các nhà máy xử lý tập trung',
        url: import.meta.env.VITE_WP_WTPM_URL,
        clientId: 'WP_WTPM',
      },
      {
        id: 3.3,
        name: 'Quản lý, giám sát và vận hành mạng lưới cấp nước tập trung',
        url: import.meta.env.VITE_WP_WDN_DESKTOP_URL,
        clientId: 'WP_WDNM',
      },
      {
        id: 3.4,
        name: 'Các ứng dụng giám sát và vận hành tại nhà máy (SCADA)',
      },
    ],
  },
  {
    id: 99,
    name: 'Quản lý ngân sách và thông tin dự án',
    type: 'link',
    isCurrent: true,
  },
  {
    id: 100,
    name: 'Quản lý đào tạo',
    type: 'link',
    url: import.meta.env.VITE_TASCO_ACADEMY_URL,
    clientId: '',
  },
]

export const APP_LIST = [
  { id: 1, name: 'Điều hành số liệu' },
  { id: 2, name: 'Khách hàng và dịch vụ' },
  { id: 1, name: 'Quản lý tài sản', url: import.meta.env.VITE_WP_ASM_URL },
  { id: 1, name: 'Vận hành sản xuất', url: import.meta.env.VITE_WP_WTPM_URL },
]

export const STATE_PROJECT = {
  BUDGET_PRESENTATION: '1', //Trình ngân sách
  APPROVE_POLICY: '2', //Duyệt chủ trương
  PROJECT_PRESENTATION: '3', //Trình dự án
  APPROVE_PROJECT: '4', //Duyệt dự án
  SIGN_CONTRACT: '5', //Ký hợp đồng
  ACCEPTANCE: '6', //Nghiệm thu
}

export const ESTIMATED_COSTS_PROJECT = [
  { key: '', value: '', unit: 'đ' },
  { key: 'Chi phí xây dựng', value: '', unit: 'đ' },
  { key: 'Chi phí thiết bị', value: '', unit: 'đ' },
  { key: 'Chi phí QLDA', value: '', unit: 'đ' },
  { key: 'Chi phí TV ĐTXDCT', value: '', unit: 'đ' },
  { key: 'Chi phí khác', value: '', unit: 'đ' },
  { key: 'Chi phí đền bù GPMB', value: '', unit: 'đ' },
  { key: 'Dự phòng phí', value: '', unit: 'đ' },
  { key: 'Chi phí lãi vay', value: '', unit: 'đ' },
  { key: 'Chi phí xây dựng', value: '', unit: 'đ' },
  { key: 'Chi phí xây dựng', value: '', unit: 'đ' },
  { key: 'Chi phí xây dựng', value: '', unit: 'đ' },
  { key: 'Chi phí sữa chữa, TT t.bị', value: '', unit: 'đ' },
]

export const ESTIMATED_COSTS_YEAR_PROJECT_OVER_APPROVED = [
  { key: 'KH giải ngân năm', value: '', unit: 'đ' },
  { key: 'KH sử dụng thực tế', value: '', unit: 'đ' },
  { key: 'Giá trị đã quyết toán', value: '', unit: 'đ' },
  { key: 'Giá trị thanh toán', value: '', unit: 'đ' },
]

export const ESTIMATED_COSTS_PROJECT_OVER_APPROVED = [
  { key: '', value: '', unit: 'đ' },
  {
    key: 'Năm',
    value: '',
    children: ESTIMATED_COSTS_YEAR_PROJECT_OVER_APPROVED,
  },
]

export const EFFECTIVE_INVEST_PROJECT = [
  { key: 'PV of FCFF', value: '', unit: 'đ' },
  { key: 'IRR', value: '', unit: '%' },
]

export const EFFECTIVE_INVEST_PROJECT_OVER_APPROVED = [
  { key: 'Tỉ lệ giải ngân', value: '', unit: '%' },
  { key: 'Tỉ lệ thanh quyết toán', value: '', unit: '%' },
]

export const APPROVE_STEP_PROJECT = [
  { key: 'Cấp DNPW', value: '' },
  { key: 'Cấp đơn vị', value: '' },
  { key: 'Người lập', value: '' },
]

export const APPROVE_STEP_PROJECT_OVER_APPROVED = [
  { key: 'Chịu trách nhiệm', value: '' },
  { key: 'Hỗ trợ', value: '' },
]

export const EXPECT_EFFECTIVE_PROJECT = [
  { key: 'Thời gian thực hiện', value: '', unit: 'Tháng' },
  {
    key: 'Hiệu quả dầu tư',
    children: [
      { key: 'Tổng mức đầu tư dự kiến trước thuế GTGT', value: '' },
      { key: 'PV of FCFF', value: '' },
      { key: 'IRR', value: '' },
      { key: 'Thời gian hoàn vốn (không chiết khấu)', value: '' },
      { key: 'Thời gian hoàn vốn (có chiết khấu)', value: '' },
    ],
  },
  {
    key: 'Sản lượng và giá thành',
    children: [
      {
        key: 'Tổng số KH mới',
        value: '',
        unit: 'KH',
        color: 'rgba(5, 66, 140, 0.7)',
      },
      {
        key: 'Tổng sản lượng tiêu thụ mới',
        value: '',
        unit: 'm3/ng',
        color: 'rgba(5, 66, 140, 0.7)',
      },
      { key: 'Sản lượng tiêu thụ bán lẻ', value: '', unit: 'm3/ng' },
      { key: 'Sản lượng tiêu thụ bán buôn', value: '', unit: 'm3/ng' },
      { key: 'Giá bán', color: 'rgba(5, 66, 140, 0.7)' },
      { key: 'Giá bán lẻ trước thuế GTGT', value: '', unit: 'vnd/m3' },
      { key: 'Giá bán buôn trước thuế GTGT', value: '', unit: 'vnd/m3' },
      {
        key: 'Chi phí sản xuất',
        value: '',
        color: 'rgba(5, 66, 140, 0.7)',
        unit: 'vnd/m3',
      },
    ],
  },
]

export const BUDGET_EXP_PROJECT = [
  { key: 'Tổng ngân sách', value: '', unit: 'đ' },
  {
    key: 'Tổng dự toán',
    value: '',
    unit: 'đ',
  },
  {
    key: 'Tổng ngân sách thực hiện',
    value: '',
    unit: 'đ',
  },
  {
    key: 'Tổng giá trị thực hiện lũy kế',
    value: '',
    unit: 'đ',
    listYear: [],
  },
  {
    key: 'Tổng giá trị thanh, quyết toán',
    value: '',
    unit: 'đ',
  },
]

export const PROJECT_STATE = {
  BUDGET_PRESENTATION: 1,
  APPROVE_POLICY: 2,
  PROJECT_PRESENTATION: 3,
  APPROVE_PROJECT: 4,
  SIGN_CONTRACT: 5,
  ACCEPTANCE: 6,
}
export const PROJECT_APPRAISAL_STATE = {
  VIEW: '0',
  EDIT: '1',
}

export const RIDERECT_REF_CODE_NOTIFI = {
  PJR_REQUEST: 'PJM_REQUEST',
  PJM_ASSET_PROJECT: 'PJM_ASSET_PROJECT',
  PJM_ALERT_AGGREGATION: 'PJM_ALERT_AGGREGATION',
  PJM_DASHBOARD_AGGREGATE: 'PJM_DASHBOARD_AGGREGATE',
  PJM_DRAFT_PROJECT: 'PJM_DRAFT_PROJECT',
}
export const REQUEST_APPRAISAL_NAME = [
  {
    label: 'Thẩm định trình ngân sách CT/DA',
    value: 'Thẩm định trình ngân sách CT/DA',
    id: 0,
  },
  {
    label: 'Thẩm định hồ sơ nhà thầu tư vấn',
    value: 'Thẩm định hồ sơ nhà thầu tư vấn',
    id: 1,
  },
  {
    label: 'Thẩm định thiết kế cơ sở, BC NCKT',
    value: 'Thẩm định thiết kế cơ sở, BC NCKT',
    id: 2,
  },

  {
    label: 'Thẩm định thiết kế thi công, dự toán',
    value: 'Thẩm định thiết kế thi công, dự toán',
    id: 3,
  },
  {
    label: 'Thẩm định hồ sơ thầu thi công xây dựng',
    value: 'Thẩm định hồ sơ thầu thi công xây dựng',
    id: 5,
  },
  {
    label: 'Thẩm định phát sinh',
    value: 'Thẩm định phát sinh',
    id: 6,
  },
  {
    label: 'Khác',
    value: 'Khác',
    id: 7,
  },
]

export const STATUS = {
  INACTIVE: 0,
  ACTIVE: 1,
}
export const totalBudgetLimit = {
  PASSLIMIT: '500000000',
}

export const GL_ASM_ASSET_PROJECT_PROJECT_STATUS = {
  IN_PROGRESS: 1,
  ON_HOLD: 2,
  CANCEL: 3,
  DONE: 4,
}

export const PJM_DRAFT_PROJECT_STATE = {
  DRAFT: 1,
  WAITING: 2,
  WAIT_UPDATE: 3,
  REJECTED: 4,
  APPROVED: 5,
  CANCEL: 6,
}
